import "bootstrap-sass";

import React from "react";
import ReactDOM from "react-dom";

import Top100Venues from "../components/top_venues/Top100Venues";

import UserTiming from "../shared/helpers/user-timing";

// from common.js
import autocompleteToggle from "../components/autocomplete/AutocompleteToggle.js";
import embedYoutube from "../components/video.js";
import initGeneralEnquiry from "../components/enquiries/general_enquiry";
import initNamedEnquiry from "../components/enquiries/named_enquiry";
import scrollspy from "../components/scrollspy/scrollspy.js";

import mountNewsletterForm from "../controllers/Newsletter.jsx";
import mountPopovers from "../controllers/Popover.jsx";

import notifier from "../shared/helpers/airbrake";
import ellipsis from "../shared/helpers/ellipsis";
import emarsys from "../shared/helpers/emarsys";
import { trackClick } from "../shared/helpers/gtm_tracking";

import "../shared/helpers/defer-picture";
import "../shared/helpers/responsive-bg";
import '../shared/gtm-script-loader';

import "./common.scss";
// end from common.js

import "../scripts/sections/blocks/autocomplete";

import "./top100.scss";

const userTiming = new UserTiming({ src: "top100" });

// from common.js
function handleClickTracking() {
  document.addEventListener("click", e => {
    const target = e.target.closest(".gtm-track-click");

    if (target) {
      trackClick(target);
    }
  });
}

// end from common.js

function onDOMContentLoaded() {
  userTiming.start("onDOMContentLoaded");

  userTiming.start("common");
  // from common.js
  autocompleteToggle();
  initGeneralEnquiry();
  initNamedEnquiry();
  handleClickTracking();
  ellipsis();
  embedYoutube();
  mountNewsletterForm();
  mountPopovers();
  scrollspy();

  // end from common.js
  userTiming.finish("common");

  const container = document.getElementById("js-top-100");
  if (container) {
    const { venueGroups } = container.dataset;

    ReactDOM.render(
      <Top100Venues
        history={window.history}
        initialGroup={window.location.hash.replace("#", "")}
        venueGroups={JSON.parse(venueGroups)}
      />,
      container
    );
  }

  userTiming.finish("onDOMContentLoaded");
}

document.addEventListener("DOMContentLoaded", onDOMContentLoaded);

// from common.js
window.addEventListener("error", error => {
  notifier.notify({ error });
});

emarsys(window.emarsysData);
// end from common.js

userTiming.finish();



// WEBPACK FOOTER //
// ./entry_points/top100.jsx